import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-reports',
  templateUrl: './payment-reports.component.html',
  styleUrls: ['./payment-reports.component.scss']
})
export class PaymentReportsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
